import channelLayoutValues from './channel-layout-values';
import layoutStyleValues from './layout-style-values';
import infoPositionValues from './info-position-values';
import showInfoActionValues from './show-info-values';
import mainItemTypeValues from './main-item-type-values';
import titlePositionValues from './title-position-values';
import channelVideoListValues from './channel-video-list-values';
import showMediaTypeValues from './show-media-type-values';
import COMPACT_PLAY_TYPE_VALUES from './compact-play-type';
import COMPACT_SHOW_VIDEO_LIST_VALUES from './compact-show-video-list';

export default {
  booleans: {
    enableVideosSharing: true,
    showChannelCategories: true,
    showChannelShare: true,
    showChannelTitle: true,
    showChannelInfo: false,
    showSearch: true,
    showSignIn: true,
    showChannelTags: true,
    showChannelVideos: true,
    showFullInfo: true,
    showVideoPublisherInList: true,
    showVideoTitleInList: true,
    showTitleForMainItem: true,
    showPublisherForMainItem: true,
    showActionBar: true,
  },
  numbers: {
    videoInfoPosition: infoPositionValues.ON_VIDEOS,
    showInfoAction: showInfoActionValues.ON_MOUSE_OVER,
    layoutStyle: layoutStyleValues.SQUARE,
    channelLayout: channelLayoutValues.CLASSIC,
    mainItemType: mainItemTypeValues.CHANNEL_COVER,
    mainItemTitlePosition: titlePositionValues.CENTER,
    videoListVisibility: channelVideoListValues.EXPAND_ON_CLICK,
    videosInRow: 4,
    mainItemOverlayOpacity: 35,
    showMediaType: showMediaTypeValues.COVER_IMAGE,
    numberOfRows: 1,
    compactPlayType: COMPACT_PLAY_TYPE_VALUES.IN_FRAME,
    compactShowVideoList: COMPACT_SHOW_VIDEO_LIST_VALUES.WHEN_CLICKED,
  },
  editMode: 'site',
};



// WEBPACK FOOTER //
// ./src/widget/player-widget/constants/default-settings/index.js